__turbopack_context__.v({
  "active": "Chip-module__4RDtPq__active",
  "chip": "Chip-module__4RDtPq__chip",
  "default": "Chip-module__4RDtPq__default",
  "disabled": "Chip-module__4RDtPq__disabled",
  "label": "Chip-module__4RDtPq__label",
});
